<template>
  <div v-if="!reloading  && !blockNewSleeker">
    <!--<carousel-item></carousel-item>-->
    <div class="content-wrapper m-t">
      <div class="list-wraper">
        <b-row id="main-row" v-if="allCarouselTemplates">
          <b-col class="text-center">
            <b-button @click="expressEdition" variant="primary">Baixar todos os cards do carrossel por {{allCarouselTemplates.length}} créditos</b-button>
            <div>
              <br/>
              <br/>
              <a href="#chooseMobileColors" class="btn btn-success" style="color: white;" variant="success">Alterar cor dos cards do carrossel</a>
            </div>
          </b-col>
        </b-row>
        <br/>
        <b-row id="main-row">
          <b-col sm="6" v-if="!isMobileScreen">
            <b-row>
              <b-col>
                <color-slider v-if="template && colors && colors.length && favoriteColors" v-bind:colors="colors" :customHeight="900" v-bind:favoriteColors="favoriteColors" v-on:changeColor="changeColor" v-bind:admin="isAdmin"/>
              </b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col class="text-center">
                <b-button v-if="isAdmin" @click="saveColor">Salvar Cor</b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="6" v-if="allCarouselTemplates">
            <spinner id="loadingDiv" class="m-t" v-if="loaded == false"></spinner>
            <b-row style="margin-bottom: 20px;" class="text-center">
              <b-col class="text-center" v-for="(templateInfo, index) in allCarouselTemplates" :key="index">
                <div v-bind:style="{'width': heightAndWidth.width + 'px'}" style="height: auto; margin: 0 auto; position: relative;" v-if="(heightAndWidth && heightAndWidth.height && heightAndWidth.width)">
                  <vue-fabric
                    v-show="!choosingElement"
                    crossorigin="Anonymous"
                    ref="canvas"
                    :width="heightAndWidth.width"
                    :height="heightAndWidth.height"
                    :background="'transparent'"
                    :backgroundImage="backgroundImage"
                    v-on:loadedBackground="loaded = true"
                    @selection:created="selected"
                    @selection:updated="selected"
                    @selection:cleared="clearedSelection"
                    @attachment:added="attachmentLoaded"
                    @object:moving="moving"
                    @object:modified="modified"
                    :canvasId="'canvas' + index"
                  ></vue-fabric>
                  <br/>
                </div>
                <b-row class="text-center">
                  <b-col>
                    <b-button @click="expressEdition(templateInfo._id)" variant="primary">Editar individualmente este card</b-button>
                  </b-col>
                </b-row>
                <br/>
              </b-col>
            </b-row>
            <br/>
          </b-col>
          <b-col id="chooseMobileColors" sm="6" v-if="isMobileScreen">
            <b-row>
              <b-col>
                <color-slider v-if="template && colors && colors.length && favoriteColors" v-bind:colors="colors" :customHeight="300" v-bind:favoriteColors="favoriteColors" v-on:changeColor="changeColor" v-bind:admin="isAdmin"/>
              </b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col class="text-center">
                <b-button v-if="isAdmin" @click="saveColor">Salvar Cor</b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import VueImageModel from "./editor/ImageModel.vue";
import Dropzone from "./Dropzone";
import service from "../service";
import { isMobile } from "mobile-device-detect";
import Spinner from "./Spinner";
import Config from "../config";
import { constants } from "fs";
import { setTimeout } from "timers";
import { Chrome } from "vue-color";
import ColorSlider from './ColorSlider.vue';

export default {
  name: "editor",
  components: {
    VueImageModel,
    dropzone: Dropzone,
    Spinner,
    ColorSlider,
    "chrome-picker": Chrome
  },
  props: {
    json: undefined,
    creation: undefined,
    customSavingUrl: undefined
  },
  data() {
    return {
      showRemoveUploadModal: false,
      uploadToRemove: undefined,
      templateId: this.$route.params.id,
      template: undefined,
      userAddedUniques: "",
      psd: false,
      imgUrl: "",
      list: [],
      isMobileScreen: isMobile,
      loading: false,
      jsonCopy: undefined,
      jsonObject: undefined,
      test1: true,
      test2: false,
      advancedEdition: false,
      backgroundImage: "",
      loaded: false,
      loadingAttachment: false,
      actionList: undefined,
      showImportImage: false,
      enableSendToBackground: false,
      currentItem: null,
      showSave: false,
      showTextEdit: false,
      showTrash: false,
      selectedIndex: -1,
      loadingJson: false,
      temporaryText: "",
      selectedColor: "#ffffff",
      changingTextColor: false,
      changingTextFont: false,
      background: "transparent",
      fontList: [
        
      ],
      updatingTextProperties: false,
      story: false,
      preventLocking: false,
      reloading: false,
      forceStory: false,
      disableSaveButton: false,
      lastJson: [],
      baseImageLoaded: false,
      preventUndo: false,
      lineSize: 0.8,
      blockNewSleeker: false,
      choosingElement: false,
      choosingElementVersion: false,
      elements: [],
      selectedElement: undefined,
      customEditorSize: "",
      heightAndWidth: {},
      imgList: [],
      colors: [],
      me: {},
      filters: { hueValue: 0, saturationValue: 0, brightnessValue: 0},
      lastColor: undefined,
      favoriteColors: [],
      allCarouselTemplates: []
    };
  },
  computed: {
    whitelabelName() {
      return localStorage.whitelabelName;
    },
    isAdmin: function() {
      return localStorage.admin;
    },
    initialMultiplier: function() {
      let baseWidth = (this.psd) ? (this.json.objects[0].width) : 1080;
      let multiplier = baseWidth / this.heightAndWidth.width;
      return multiplier;
    },
    finalMultiplier: function() {
      let baseWidth = 1080;
      let multiplier = baseWidth / this.heightAndWidth.width;
      return multiplier;
    },
    finalImageMultiplier: function() {
      let baseWidth = this.story ? 1080 : 1200;

      if (this.template && this.template.customEditorWidth) {
        baseWidth = this.template.customEditorWidth;
      }
      
      let multiplier = baseWidth / this.heightAndWidth.width;
      return multiplier;
    },
    isInstagramBrowser: function() {
      var str = navigator.userAgent;
      
      var i = str.indexOf("Instagram");
      if (i <= -1) {
        return false;
      }
      return true;
    }
  },
  created() {
    this.getColors();
    service.getMe().then(
      response => {
        this.me = response;
      },
      () => {
        this.showError = true;
      }
    );
  },
  mounted() {
    this.reload();
  },
  methods: {
    goToEditor() {
      if (this.$route.query.firstEdition) {
        //?firstEdition1
      }
    },
    expressEdition: function(chosenId) {
      //if (this.me.emailConfirmationTime || this.me.subscription.status != 2) {
        //service.useTemplate(this.template._id).then(
          //response => {
            let params = { firstEdition: false, shouldAllow: true, id: chosenId }

            params.filters = this.filters;

            if (this.customSavingUrl) {
              params.customSavingUrl = this.customSavingUrl;
            }
            
            if (this.lastColor) {
              service.registerColorUse(this.lastColor);
            }

            this.$router.push({ name: 'Editor', params: params });
            
            // Create the event
            //var event = new CustomEvent("update-me", {});

            // Dispatch/Trigger/Fire the event
            //document.dispatchEvent(event);
          //},
          //() => {
            //this.showError = true;
          //}
        //);
      /*} else {
        this.forbiddenEdition = true;
      }*/
    },
    changeColor(filters) {
      
      this.lastHue = filters.hueValue;
      this.lastSaturation = filters.saturationValue;
      this.lastBrightness = filters.brightnessValue;
      this.filters = filters;
      console.log("12121");
      for (let key in this.allCarouselTemplates) {
        let layer = 1;
        if (this.allCarouselTemplates[key].layer) {
          layer = this.allCarouselTemplates[key].layer - 1;
        }

        if (filters.id) {
          this.lastColor = filters.id;
        }
          
        this.$refs.canvas[key].applyFilterToImage(layer, filters);
      }

      
    },
    saveColor() {
      service.saveColor({hue: this.lastHue, saturation: this.lastSaturation, brightness: this.lastBrightness}).then(() => {
        this.getColors();
      });
    },
    getColors() {
      service.getColors().then((result) => {
        

        if (result.favoriteColors && result.favoriteColors.length) {
          this.favoriteColors = [];

          for (let key in result.colors) {
            if (result.favoriteColors.indexOf(result.colors[key]._id) >= 0) {
              this.favoriteColors.push(result.colors[key]);
            }
          }
        }

        this.colors = result.colors;
      });
    },
    handleCompleteLoad() {
      if (this.baseImageLoaded == false) {

      } else {
        
      }
    },
    reload(force) {
      this.reloading = false;
      this.loaded = false;

      if (force == true) {
        this.loaded = true;
      }

      service.getCarouselTemplateById(this.templateId).then(
        response => {
          this.allCarouselTemplates = response.allCarouselTemplates;
          for (let key in this.allCarouselTemplates) {
            this.template = response.allCarouselTemplates[key];
            this.story = this.forceStory ? true : this.template.story;

            this.calculateHeightAndWidth();

            if (this.template.advancedEdition == true && this.template.json != null) {
              if (this.template.json.objects.length > 1) {
                this.advancedEdition = true;
                this.jsonObject = this.template.json.objects;
                this.backgroundColor = this.template.json.background;
                let jsonToLoad = this.calculateScale();
                this.loaded = true;

                this.loadJSON(jsonToLoad, null, this.handleCompleteLoad, null, key);
              } else {
                this.setBackgroundImage(this.template.fullImage + "?" + Math.random());
                this.advancedEdition = false;
              }
            } else {
              this.setBackgroundImage(
                this.template.fullImage + "?" + Math.random()
              );
              this.advancedEdition = false;
              //this.loaded = true;
            }
          } 
        },
        () => {
          //this.loaded = true;
          this.loadingJson = false;
        }
      );
    },
    calculateHeightAndWidth() {
      let baseHeight = (this.isMobileScreen) ? 250 : 360;
      let baseWidth = (this.isMobileScreen) ? 250 : 360;

      if (this.story) {
        baseHeight = (this.isMobileScreen) ? 250 : 480;
        baseWidth = (this.isMobileScreen) ? 140 : 270;
      }

      if (this.template && this.template.customEditorHeight && this.template.customEditorWidth) {
        let heightFactor = this.template.customEditorHeight / baseHeight;
        let widthFactor = this.template.customEditorWidth / baseWidth;
        let finalFactor = (widthFactor > heightFactor) ? widthFactor : heightFactor;
        let height = this.template.customEditorHeight / finalFactor;
        let width = this.template.customEditorWidth / finalFactor;
        
        this.heightAndWidth = { height: height, width: width };
      } else {
        this.heightAndWidth = { height: baseHeight, width: baseWidth };
      }
    },
    unlockAll() {
      this.preventLocking = true;
      if (this.actionList) {
        this.loadJSON(this.actionList, true, () => {});
      }
    },
    setBackgroundImage(backgroundImage) {
      //this.loadingJson = true;
      if (!this.$refs.canvas[0]) {
        setTimeout(() => {
          this.setBackgroundImage(backgroundImage);
        }, 100);
        return;
      }

      this.backgroundImage = backgroundImage;
      //this.loadingJson = false;
    },
    resetControls() {
      this.loadJSON(this.$refs.canvas[0].toJson(), true);
    },
    changeTextColor() {
      let copyItem = JSON.parse(JSON.stringify(this.$refs.canvas[0].toJson())); //deepCopy
      this.lastJson.push(copyItem);

      this.updatingTextProperties = true;
      this.changingTextColor = false;
      this.currentItem.fill = this.selectedColor.hex;
      if (this.currentItem && this.currentItem.styles) {
        for (let style in this.currentItem.styles) {
          for (let styleItem in this.currentItem.styles[style]) {
            this.currentItem.styles[style][styleItem].fill = this.selectedColor;
          }
        }
      }
      this.loadJSON(this.$refs.canvas[0].toJson(), null, () => {
        this.updatingTextProperties = false;
      });
    },
    changeTextFont(font) {
      let copyItem = JSON.parse(JSON.stringify(this.$refs.canvas[0].toJson())); //deepCopy
      this.lastJson.push(copyItem);

      this.updatingTextProperties = true;
      this.changingTextFont = false;
      this.currentItem.fontFamily = font;
      if (this.currentItem && this.currentItem.styles) {
        for (let style in this.currentItem.styles) {
          for (let styleItem in this.currentItem.styles[style]) {
            this.currentItem.styles[style][styleItem].fontFamily = font;
          }
        }
      }
      this.loadJSON(this.$refs.canvas[0].toJson(), null, () => {
        this.updatingTextProperties = false;
      });
    },
    saveText() {
      this.currentItem.text = this.temporaryText;

      this.loadJSON(this.$refs.canvas[0].toJson());
    },
    loadUploads() {
      service.getUploads().then(
        response => {
          if (response && response.result) {
            this.list = response.result;
          }
        },
        () => {
          this.showError = true;
        }
      );
    },
    decodeString(str) {
      return  str.replace(/\\xe3/g,"ã").replace(/\\r/g,"\n").replace(/\\xc7/g,"Ç").replace(/\\xc1/g,"Á").replace(/\\xe1/g,"á").replace(/\\xc3/g,"Ã").replace(/\\xea/g,"ê").replace(/\\xca/g,"Ê").replace(/\\xed/g,"í").replace(/\\xcd/g,"Í").replace(/\\xf5/g,"õ").replace(/\\xd5/g,"Õ").replace(/\\xe9/g,"é").replace(/\\xc9/g,"É").replace(/\\xf3/g,"ó").replace(/\\xd3/g,"Ó").replace(/\\xfa/g,"ú").replace(/\\xda/g,"Ú").replace(/\\xe7/g,"ç");      
    },
    loadJSON(json, preventEditOptionsClosing, cb, decodeStrings, canvasIndex) {
      if (!this.$refs.canvas || !this.$refs.canvas[canvasIndex]) {
        setTimeout(() => {
          this.loadJSON(json, preventEditOptionsClosing, cb, decodeStrings, canvasIndex);
        }, 2000);
        return;
      }

      console.log(this.$refs.canvas[canvasIndex]);


      this.actionList = [];
      var index = 0;
      this.loadingJson = true;
      let jsonBack = undefined;
      let biggest = 0;

      this.actionList = json;
      for (let i = 0; i < this.actionList.objects.length; i++) {
        let templateItem = this.actionList.objects[i];

        this.actionList.objects[i].hasControls = false;
        this.actionList.objects[i].lockRotation = true;
        this.actionList.objects[i].lockMovementX = true;
        this.actionList.objects[i].lockMovementY = true;
        this.actionList.objects[i].evented = false;

        if (
          (this.actionList.objects[i] &&
            (this.actionList.objects[i].type &&
              this.actionList.objects[i].type == "i-text")) ||
          this.actionList.objects[i].text
        ) {
          this.actionList.objects[i].id = index;
          if (decodeStrings) {
            this.actionList.objects[i].text = this.decodeString(this.actionList.objects[i].text);
          }
          index++;
          if (this.isMobileScreen) {
            this.actionList.objects[i].editable = false;
          }
        } else if (
          this.actionList.objects[i] &&
          this.actionList.objects[i].type &&
          this.actionList.objects[i].type == "image"
        ) {
          this.imgList.push(this.actionList.objects[i]);
          this.actionList.objects[i].crossOrigin = "anonymous";
          this.actionList.objects[i].filters = [new       fabric.Image.filters.HueRotation()];
        }
        if (
          this.actionList.objects[i].scaleX * this.actionList.objects[i].width >
          biggest
        ) {
          biggest =
            this.actionList.objects[i].scaleX *
            this.actionList.objects[i].width;
          jsonBack = this.actionList.objects[i];
        }
        if (
          this.actionList.objects[i].scaleY *
            this.actionList.objects[i].height >
          biggest
        ) {
          biggest =
            this.actionList.objects[i].scaleY *
            this.actionList.objects[i].height;
          jsonBack = this.actionList.objects[i];
        }
      }

      if (jsonBack && !this.actionList.backgroundImage) {
        /*
        if (this.preventLocking) {
          jsonBack.hasControls = true;
          jsonBack.lockRotation = false;
          jsonBack.lockMovementX = false;
          jsonBack.lockMovementY = false;
        } else {
          jsonBack.hasControls = false;
          jsonBack.lockRotation = true;
          jsonBack.lockMovementX = true;
          jsonBack.lockMovementY = true;
        }
        */
      } else if (this.actionList.backgroundImage) {
        this.actionList.backgroundImage.crossOrigin = "anonymous";
      }

      if (json && json.objects && json.objects.length > 0) {
        console.log("Carregando o json");
        console.log(JSON.stringify(json).length);
        console.log("no canva " + canvasIndex);

        console.log(window.document.getElementById("canvas1"))
        this.$refs.canvas[canvasIndex].loadFromJSON(json, () => {
          this.loaded = true;
          this.currentItem = undefined;
          this.loadingJson = false;
          this.preventUndo = false;
          
          if (!preventEditOptionsClosing) {
            this.showImportImage = false;
            this.enableSendToBackground = false;
            this.showSave = false;
            this.showTextEdit = false;
          }

          if (cb) {
            cb();
          }
        });
      } else {
        if (cb) {
          cb();
        }
        this.loadingJson = false;
      }
    },
    startUploadRemoval(item) {
      this.uploadToRemove = item;
      this.showRemoveUploadModal = true;
    },
    removeUpload(item) {
      this.showRemoveUploadModal = false;
      service.removeUpload(item.url).then(
        response => {
          this.loadUploads();
        },
        () => {
          this.showError = true;
        }
      );
    },
    uploadAmountError() {
      alert('O limite de uploads é 6. Remova alguns para adicionar novos.');
    },
    clearedSelection() {
      this.showTextEdit = false;
      this.enableSendToBackground = false;
      this.currentItem = null;
      this.showImportImage = true;
      this.showSave = true;
      this.showTrash = false;
      this.showImportImage = false;
    },
    selected(obj, option) {
      this.showTrash = false;
      if (isMobile == true) {
        if (obj && obj.target) {
          if (
            (obj.target.type && obj.target.type == "i-text") ||
            obj.target.text
          ) {
            this.currentItem = obj.target;
            this.showTextEdit = true;
            this.temporaryText = obj.target.text;
            this.showImportImage = false;
            this.enableSendToBackground = false;
            this.showSave = false;
            this.textToEdit = obj.target.text;
          }
          if (
            obj.target.type &&
            obj.target.type == "image" &&
            obj.target.hasControls
          ) {
            this.currentItem = obj.target;
            this.showTextEdit = false;
            this.showImportImage = false;
            this.enableSendToBackground = true;
            this.showSave = false;
            this.showTrash = true;
          }
        }
      } else {
        this.showTextEdit = false;
        this.enableSendToBackground = false;
        this.currentItem = null;
        if (obj && obj.target) {
          if (
            (obj.target.type && obj.target.type == "i-text") ||
            obj.target.text
          ) {
            this.showTextEdit = true;
            this.currentItem = obj.target;
          } else if (
            obj.target.type &&
            obj.target.type == "image" &&
            obj.target.hasControls
          ) {
            this.enableSendToBackground = true;
            this.currentItem = obj.target;
          }
        }
      } 
    },
    moving(obj, option) {
      if (obj.target.id == "bg") {
        obj.target.top = this.heightAndWidth.height / 2;
        obj.target.left = this.heightAndWidth.width / 2;
      }
    },
    modified(obj, option) {
      let copyItem = JSON.parse(JSON.stringify(this.$refs.canvas[0].toJson())); //deepCopy
      this.lastJson.push(copyItem);
    },
    undoAction() {
      if (this.lastJson.length > 1) {
        let historySize = this.lastJson.length;
        let jsonToLoad = this.lastJson.pop();
        //this.lastJson = this.lastJson.splice(- 1, 1);
        historySize = this.lastJson.length;
        this.preventUndo = true;
        if (this.advancedEdition == true) {
          this.loadJSON(jsonToLoad);
        } else {
          this.preventUndo = true;
          this.reload(true);
        }
        return;
      }
      this.preventUndo = true;
      this.reload(true);
    },
    onFileInputChanged(event) {
      this.uploadFiles(event.target.files);
    },
    trigger() {
      this.$refs.fileInput.click();
    },
    attachmentLoaded() {
      this.loadingAttachment = false;
    },
    uploadFiles(files) {
      this.loading = true;

      let reader = new FileReader();

      reader.addEventListener(
        "load",
        function() {
          this.showPreview = true;
          this.imagePreview = reader.result;
        }.bind(this),
        false
      );

      reader.readAsDataURL(files[0]);
      this.loading = true;

      var formData = new FormData();
      formData.append("file", files[0]);

      const baseURL = Config.BASE_API_URL;

      var vm = this;
      fetch(baseURL + "upload-file", {
        headers: {
          "Conectados-Auth": localStorage.sessionId
        },
        method: "POST",
        body: formData,
        bypassInterceptor: true
      }).then(function(response) {
        if (response && response.status && response.status === 200) {
          vm.$emit("uploadComplete");
          vm.imagePreview = "";
          vm.loading = false;
          vm.loadUploads();
        } else {
          alert("Houve um problema com seu upload :( Tente novamente mais tarde");
          vm.loading = false;
        }
      });
      //this.loadUploads();
    },
    calculateScale() {
      var jsonCopyItem = { objects: [] };

      var jsonObjectsCopy = JSON.parse(JSON.stringify(this.jsonObject));

      for (var i = 0; i < jsonObjectsCopy.length; i++) {
        jsonObjectsCopy[i].scaleX = jsonObjectsCopy[i].scaleX / this.initialMultiplier;
        jsonObjectsCopy[i].scaleY = jsonObjectsCopy[i].scaleY / this.initialMultiplier;
        jsonObjectsCopy[i].left = jsonObjectsCopy[i].left / this.initialMultiplier;
        jsonObjectsCopy[i].top = jsonObjectsCopy[i].top / this.initialMultiplier;

        jsonCopyItem.objects.push(jsonObjectsCopy[i]);
      }

      if (this.backgroundColor) {
        jsonCopyItem.background = this.backgroundColor;
      }

      return jsonCopyItem;
    }
  }
};
</script>
